<template>
    <van-popup v-model="showState" :close-on-click-overlay="false">
        <img class="qrcode" src="https://res.peki.vip/20220913/c006108f76ae47318a547338eaceaa27.jpeg" />
    </van-popup>
</template>
<script>
export default {
    props: ['isShow'],
    data() {
        return {
            showState: false,
        }
    },
    watch: {
        isShow: function () {
            this.showState = true
        },
    },
}
</script>
<style lang="scss" scoped>
.qrcode {
    width: 240px;
}
</style>
